import React from 'react';
import { useTranslation } from 'react-i18next';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { ServicesBookingScheduling } from '@components/templates';

export function ServicesBookingSchedulingPage() {
    const { t } = useTranslation();

    const translations = {
        title: t('services-booking-scheduling-component.metatags.title'),
        description: t('services-booking-scheduling-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.servicesBookingScheduling,
        index: false,
    });

    return <ServicesBookingScheduling />;
}
